define('modules/ProductLease/ProductLease.Forms',[], function () {
    'use strict';

    // Forms definitions
    var forms = {
        'Productlease': {
            Fields: [
                { 'Name': 'FirstName', 'Field': '#productLease_firstname', 'Param': 'FirstName', 'Type': 'Text' },
                { 'Name': 'LastName', 'Field': '#productLease_lastname', 'Param': 'LastName', 'Type': 'Text' },
                { 'Name': 'Email', 'Field': '#productLease_email', 'Param': 'Email', 'Type': 'Text', 'Validators': [{ 'Type': 'Email' }] },
                { 'Name': 'Company', 'Field': '#productLease_company', 'Param': 'Company', 'Type': 'Text' },
                { 'Name': 'Address1', 'Field': '#productLease_address1', 'Param': 'Address1', 'Type': 'Text' },
                { 'Name': 'Address2', 'Field': '#productLease_address2', 'Param': 'Address2', 'Type': 'Text', 'Optional': true },
                { 'Name': 'City', 'Field': '#productLease_city', 'Param': 'City', 'Type': 'Text' },
                { 'Name': 'State', 'Field': '#productLease_state', 'Param': 'State', 'Type': 'Text' },
                { 'Name': 'Zip', 'Field': '#productLease_zip', 'Param': 'Zip', 'Type': 'Text' },
                { 'Name': 'Country', 'Field': '#productLease_country', 'Param': 'Country', 'Type': 'Text' },
            ],
            Validate: true
        }
    };

    return forms;
});
